<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-faq"
    >
        <y-container>
            <y-row>
                <y-col>
                    <y-breadcrumb
                        :items="breadItems"
                        color="disabled"
                        divider="angle-left"
                    />
                </y-col>
            </y-row>
            
            <y-row v-if="faq && faq.length">
                <y-col md="4">
                    <div class="d-flex align-items-baseline">
                        <y-icon
                            icon="mdi-tag"
                            library="mdi"
                            color="body"
                            size="small"
                        />
                        <y-section-title
                            type="standard"
                            :subtitle="$t('faq.title_category')"
                        />
                    </div>
                    
                    <div class="m-faq__section-category">
                        <div
                            v-for="item in faq"
                            :key="`${item.id}-${item.title}`"
                            :class="['m-faq__section-category__item', item.slug === selectedCategory ? 'active' : '' ]"
                            @click.prevent="selectedCategory = item.slug"
                        >
                            <span :class="['typo-h6', `color-${selectedCategory === item.slug ? 'primary' : 'body'}-text`]">
                                {{ item.title }}
                            </span>
                        </div>
                    </div>
                </y-col>
                <y-col md="8">
                    <y-section-title
                        type="standard"
                        :title="$t('faq.title')"
                    />
                    <y-faq
                        v-if="childrens.length > 0"
                        type="simple"
                        :items="childrens"
                    />
                    <y-empty v-else />
                </y-col>
                <y-col>
                    <div class="m-faq__sales-feature">
                        <y-section-title
                            type="standard"
                            :title="$t('faq.feature_title')"
                            class="m-faq__sales-feature__title"
                        />
                        <y-list-wrapper
                            v-if="salesFeatures && salesFeatures.length"
                            type="grid"
                            limit="3"
                            class="m-faq__sales-feature__item"
                            :component="{
                                name: 'YInfoBox',
                                type: 'Simple',
                                imageVersion: 'main'
                            }"
                            size="4"
                            :col="{
                                lg: 4,
                                md: 4,
                                xs: 12,
                            }"
                            :items="salesFeatures"
                            no-scroll
                        />
                    </div>
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>

<script>

    import {
        YContainer, YRow, YCol, YIcon, YBreadcrumb, YEmpty,
    } from '@components';
    import { YFaq, YSectionTitle, YListWrapper } from '@rogues';
    import PageMixin from '@nodes/mixins/Page';

    export default {
        name: 'FAQPage',

        components: {
            YFaq,
            YSectionTitle,
            YListWrapper,
            YContainer,
            YRow,
            YCol,
            YIcon,
            YBreadcrumb,
            YEmpty,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle       : this.$t('faq.title'),
                faq             : null,
                selectedCategory: null,
                salesFeatures   : [],
                breadItems      : [
                    {
                        title: this.$t('home.title'),
                        icon : 'house',
                        route: {
                            name: 'home',
                        },
                    },
                    {
                        title: this.$t('faq.title'),
                        route: this.$router,
                    },
                ],
            };
        },
        
        computed: {
            /**
             * Return Selected faq category list
             * 
             * @returns {Array}
             */
            childrens() {
                return this.faq.find((item) => item.slug === this.selectedCategory).children;
            },
        },

        methods: {
            /**
             * Fetch faq data
             * 
             * @returns {Promise}
             */
            fetch() {
                const faq = this.$services.ContentThemes.faqList({
                    slug     : 'faq',
                    locale   : this.$i18n.locale,
                    including: ['title', 'slug', 'image'],
                }).catch((error) => {
                    this.handleError(error);
                });

                const salesFeatures = this.$services.Content.postList({
                    type     : 'sales-features',
                    locale   : this.$i18n.locale,
                    including: ['title', 'image:img', 'custom'],
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([faq, salesFeatures]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.faq = responses[0].data.results.filter((item) => item.id);
                        this.selectedCategory = responses[0].data.results[0].slug;
                    }
                    if (this.handleReq(responses, 1)) {
                        this.salesFeatures = responses[1].data.results;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>

<style lang="scss" src="../scss/faq.scss"/>
